// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__U6Czz","colCheckbox":"styles_colCheckbox__1-vMo"};